import {Grid} from '@mui/material';
import {useState} from 'react';
import {CSSTransition} from 'react-transition-group';
import Wizard from 'components/AddOrEditForm/Wizard';
import AddOrEditPatient from 'components/AddOrEditForm/AddOrEditPatient';
import useRegisterPatient from 'hooks/useRegisterPatient';
import {ModalSendDoctor} from './ModalSendDoctor';
import {detectPathUrl} from 'helpers/detectPathUrl';
import {useNavigate} from 'react-router-dom';
import {useDoctorList} from 'hooks/useScan';
import useAgentInfo from 'hooks/useAgentInfo';

const RegisterPatient = ({nfcData, activeDoctorId}) => {
  const {data: agentInfo} = useAgentInfo();

  const [step, setStep] = useState(1);
  const [showTransition, setShowTransition] = useState(false);
  const [successfullySend, setSuccessfullySend] = useState(null);
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState(null);
  const [patientId, setPatientId] = useState(null);
  const navigate = useNavigate();

  const nextStepHandler = () => {
    if (step === 2) return;
    setShowTransition(!showTransition);
    setStep((prev) => prev + 1);
  };

  const backStepHandler = () => {
    setShowTransition(!showTransition);
    if (step === 1) return;
    setStep((prev) => prev - 1);
  };

  const {data: doctorList} = useDoctorList();
  const registerPatient = useRegisterPatient();
  const selectedDoctorId =
    doctorList.length > 0
      ? doctorList?.find((item, index) => index === activeDoctorId)?.id
      : doctorList[0]?.id;

  const registerHandler = (userData) => {
    if (step === 2) {
      setUserData(userData);
      registerPatient.mutate({
        assistantMappingId: selectedDoctorId,
        nfcData,
        userData,
        setSuccessfullySend,
        setPatientId,
        setOpen,
        isScanCenter: agentInfo?.isScanCenter,
      });
    }
    nextStepHandler();
  };
  const successHandler = () => {
    setSuccessfullySend(true);
    navigate(detectPathUrl(`app/report?patientId=${patientId}`), {
      replace: true,
    });
    setOpen(false);
  };

  const titleText =
    step === 1 ? 'اطلاعات ثبت نام بیمار جدید' : 'اطلاعات تکمیلی بیمار';
  const inParenthesesText = step === 2 ? 'اختیاری' : '';

  return (
    <Grid container padding={'16px'}>
      <Wizard
        stepLength={2}
        titleText={titleText}
        inParenthesesText={inParenthesesText}
        backStepHandler={backStepHandler}
        activeStep={step}>
        <CSSTransition
          in={showTransition}
          classNames={{
            enterDone: 'animate__animated animate__fadeInRight',
            enterActive: 'animate__animated animate__fadeInRight',
          }}>
          <AddOrEditPatient
            type='add'
            activeStep={step}
            requiredFields={step === 1}
            actionHandler={registerHandler}
            nextStepHandler={nextStepHandler}
            backStepHandler={backStepHandler}
            disabled={registerPatient.isLoading}
          />
        </CSSTransition>
      </Wizard>
      {open && (
        <ModalSendDoctor
          open={open}
          setOpen={setOpen}
          successfullySend={successfullySend}
          retryHandler={() => registerHandler(userData)}
          successHandler={() => successHandler()}
          activeDoctorId={activeDoctorId}
        />
      )}
    </Grid>
  );
};

export default RegisterPatient;
